<template>
    <UiHeader />
    <div>
        <ShopwareAccountHero />
    </div>
    <slot />
    <ScrollToTop />
    <UiFooter :siteConfig="siteConfig" />
</template>

<script setup lang="ts">
    const siteConfig = await useSiteSettings();

    provide('user', { ...useUser().user.value });
</script>
